import { Extension } from '@tiptap/core';

const TextDirection = Extension.create({
  name: 'textDirection',

  addOptions() {
    return {
      types: ['heading', 'paragraph', 'listItem', 'orderedList', 'bulletList'],
      directions: ['ltr', 'rtl', 'auto'],
      defaultDirection: 'auto',
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          dir: {
            default: this.options.defaultDirection,
            parseHTML: (element) => {
              const currDir = element.dir;
              if (currDir && this.options.directions.includes(currDir)) {
                return currDir;
              } else {
                return this.options.defaultDirection;
              }
            },
            renderHTML: (attributes) => {
              return { dir: attributes.dir };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setTextDirection:
        (direction) =>
        ({ commands }) => {
          const textAlign = direction === 'ltr' ? 'left' : 'right';
          if (!this.options.directions.includes(direction)) {
            return false;
          }
          return this.options.types.every((type) =>
            commands.updateAttributes(type, {
              dir: direction,
              textAlign: textAlign,
            })
          );
        },
      unsetTextDirection:
        () =>
        ({ commands }) => {
          return this.options.types.every((type) =>
            commands.resetAttributes(type, 'dir')
          );
        },
    };
  },
});

export default TextDirection;
export { TextDirection };
